// extracted by mini-css-extract-plugin
export default {"title-section":"_1CjTXzYx9m","titleSection":"_1CjTXzYx9m","table":"_1_Ukq3uh3X","status":"_1PwXn_E_cy"};
    if(module.hot) {
      // 1623933174413
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  